<template>
    <div id="app">

      <router-view/>

        <div class="logo" >
          <img src="./assets/img/logo.svg" alt="Logo" >
        </div>
        <div class="tabs">
          <div id="nav">
              <div v-for="(step, index) in steps" :key="index" :class="{'active': stepActive == index+1, 'step-finish': index == 5,'hidden': index==10 }" ><a href="javascript:void(0);" :class="{'active': stepActive == index+1, 'done': stepActive > index+1 }">{{ step }}</a></div>
          </div>
          <div id="tabs-body">
          
              <div id="step-1" :class="{'active': stepActive === 1}" >
                <Subject ref="step1" @openNextPage="subjectNextPage" />
              </div>

              <div id="step-2" :class="{'active': stepActive === 2}" >
                <PersonalData ref="step2" @openNextPage="personalDataNextPage" />
              </div>

              <div id="step-3" :class="{'active': stepActive === 3}" >
                <ContactData ref="step3" @openNextPage="contactDataNextPage" />
              </div>

              <div id="step-4" :class="{'active': stepActive === 4}" >
                <DateData ref="step4" @openNextPage="dateDataNextPage" />
              </div>

              <div id="step-5" :class="{'active': stepActive === 5}" >
                <Conclusion ref="step5" @jumpTo="jumpTo" />
              </div>

              <div id="step-6" :class="{'active': stepActive === 6}" >
                <Success ref="step6" />
              </div>

              <div class="container prevnext-buttons" v-if="stepActive != 6" >
                <div class="row">
                  <div class="col-6 back-button" >
                      <a href="javascript:void(0);" tag="button" class="button" v-on:click="prevPage();" v-if="stepActive > 1 && stepActive < 6" >Zurück</a>
                  </div>
                  <div class="col-6 next-button"  v-if="stepActive < 5">
                      <a href="javascript:void(0);" tag="button" class="button" v-on:click="nextPage();" >Weiter</a>
                  </div>
                  <div class="col-6 submit-button" v-if="stepActive == 5">
                      <a href="javascript:void(0);" tag="button" class="button" v-on:click="submitForm();" >Anfrage jetzt versenden</a>
                  </div>
                </div>
              </div>

          </div>
        </div>


        <modals-container />
        <v-dialog/>
    </div>

</template>

<script>  
  import Subject from './views/Subject'
  import PersonalData from './views/PersonalData'
  import ContactData from './views/ContactData'
  import DateData from './views/DateData'
  import Conclusion from './views/Conclusion'
  import Success from './views/Success'


  import 'vue-datetime/dist/vue-datetime.css'

  export default {
    name: 'form',
    components: {
      Subject,
      PersonalData,
      ContactData,
      DateData,
      Conclusion,
      Success
    },

    data: function () {
      return {
        steps: ['Unterrichtsfach', 'Nachhilfeort', 'Kontaktdaten', 'Probetermin', 'Fast Fertig', 'Fertig'],
        stepActive: 1,

        subjectData: [],
        personalData: [],
        contactData: [],
        dateData: [],
      }
    },

    methods: {
      prevPage() {
        this.stepActive--;
      },
      nextPage() {
        switch (this.stepActive) {
          case 1:
            this.$refs.step1.nextPage();
            break;
          case 2:
            this.$refs.step2.nextPage();
            break;
          case 3:
            this.$refs.step3.nextPage();
            break;
          case 4:
            this.$refs.step4.nextPage();
            break;
        }
      },
      subjectNextPage(data) {
        this.subjectData = data;
        this.stepActive = 2;
        window.scrollTo(0,0);
      },
      personalDataNextPage(data) {
        this.personalData = data;
        this.stepActive = 3;
        window.scrollTo(0,0);
      },
      contactDataNextPage(data) {
        this.contactData = data;
        this.stepActive = 4;
        window.scrollTo(0,0);
      },
      dateDataNextPage(data) {
        this.dateData = data;
        this.stepActive = 5;
        window.scrollTo(0,0);
      },

      jumpTo(step) {
        this.stepActive = step;
        window.scrollTo(0,0);
      },

      submitForm() {
        // In DB eintragen
        this.$http
          .post('https://api.mueller-helpings.de/mh/items/anfrage', {
              faecher: JSON.stringify(this.subjectData.rows),
              jahr: this.subjectData.year,
              schultyp: this.subjectData.schooltype,
              strasse: this.personalData.route,
              hausnummer: this.personalData.street_number,
              plz: this.personalData.postal_code,
              stadt: this.personalData.locality,
              vorname: this.contactData.forename,
              nachname: this.contactData.lastname,
              telefon: this.contactData.phone,
              mail: this.contactData.mail,
              vorschlag_1: this.dateFormat(this.dateData.dateOne),
              vorschlag_2: this.dateFormat(this.dateData.dateTwo),
              vorschlag_3: this.dateFormat(this.dateData.dateThree),
            }, {
              headers: {
                  "Authorization" : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                  "Content-Type"  : "application/json"
              }}
          )
          .then(response => (this.info = response))
          .catch(error => console.log(error))

        // Mail versenden Kunde und Admin
        

        this.$http
          .post('https://api.mueller-helpings.de/mh/mail', {
              "to": [
                {"email": this.contactData.mail, "name": this.contactData.forename + ' ' + this.contactData.lastname }
              ],
              "from": {"nachhilfe@mueller-helpings.de": "müller helpings Nachhilfe GbR"},
              "subject": "Deine Nachhilfeanfrage",
              "body": `<p>Vielen Dank für Deine Anfrage. Wir setzen uns mit Dir in Verbindung. Checke auch Deinen Spam-Ordner und höre Deine Mailbox ab!</p>
              <p>Dein müller helpings Team</p><br>
              <p><b>Folgendes hast Du an uns übermittelt:</b></p>
              
              <p>{{vorname}} {{nachname}}<br>
              {{telefon}}, {{mail}}<br>
              {{strasse}} {{hausnummer}}, {{plz}} {{stadt}}</p>

              <p>{{jahr}}. Klasse, {{schultyp}}<br>
              Fächer: {{faecher}}</p>

              <p>Probetermin-Vorschläge: <br>{{vorschlag_1}}<br> {{vorschlag_2}}<br> {{vorschlag_3}}</p>`,
              "type": "html",
              "data": {
                faecher: this.implode(this.subjectData.rows),
                jahr: this.subjectData.year,
                schultyp: this.subjectData.schooltype,
                strasse: this.personalData.route,
                hausnummer: this.personalData.street_number,
                plz: this.personalData.postal_code,
                stadt: this.personalData.locality,
                vorname: this.contactData.forename,
                nachname: this.contactData.lastname,
                telefon: this.contactData.phone,
                mail: this.contactData.mail,
                vorschlag_1: this.dateFormatReadable(this.dateData.dateOne),
                vorschlag_2: this.dateFormatReadable(this.dateData.dateTwo),
                vorschlag_3: this.dateFormatReadable(this.dateData.dateThree)
              }
            }, {
              headers: {
                  "Authorization" : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                  "Content-Type"  : "application/json"
              }}
          )
          .then(response => (self.info = response))
          .catch(error => console.log(error))

        this.$http
          .post('https://api.mueller-helpings.de/mh/mail', {
              "to": [
                {"email": "nachhilfe@mueller-helpings.de", "name": "mueller-helpings"}
              ],
              "from": {"nachhilfe@mueller-helpings.de": "müller helpings Nachhilfe GbR"},
              "subject": "Neue Nachhilfeanfrage",
              "body": `<p><b>Folgende Daten wurden übermittelt:</b></p>
              
              <p>{{vorname}} {{nachname}}<br>
              {{telefon}}, {{mail}}<br>
              {{strasse}} {{hausnummer}}, {{plz}} {{stadt}}</p>

              <p>{{jahr}}. Klasse, {{schultyp}}<br>
              Fächer: {{faecher}}</p>

              <p>Probetermin-Vorschläge: <br>{{vorschlag_1}}<br> {{vorschlag_2}}<br> {{vorschlag_3}}</p>`,
              "type": "html",
              "data": {
                faecher: this.implode(this.subjectData.rows),
                jahr: this.subjectData.year,
                schultyp: this.subjectData.schooltype,
                strasse: this.personalData.route,
                hausnummer: this.personalData.street_number,
                plz: this.personalData.postal_code,
                stadt: this.personalData.locality,
                vorname: this.contactData.forename,
                nachname: this.contactData.lastname,
                telefon: this.contactData.phone,
                mail: this.contactData.mail,
                vorschlag_1: this.dateFormatReadable(this.dateData.dateOne),
                vorschlag_2: this.dateFormatReadable(this.dateData.dateTwo),
                vorschlag_3: this.dateFormatReadable(this.dateData.dateThree)
              }
            }, {
              headers: {
                  "Authorization" : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                  "Content-Type"  : "application/json"
              }}
          )
          .then(response => (self.info = response))
          .catch(error => console.log(error))

          this.$http
          .post('https://api.mueller-helpings.de/mh/mail', {
              "to": [
                {"email": "me@konbirdy.de", "name": "mueller-helpings"}
              ],
              "from": {"nachhilfe@mueller-helpings.de": "müller helpings Nachhilfe GbR"},
              "subject": "Neue Nachhilfeanfrage",
              "body": `<p><b>Folgende Daten wurden übermittelt:</b></p>
              
              <p>{{vorname}} {{nachname}}<br>
              {{telefon}}, {{mail}}<br>
              {{strasse}} {{hausnummer}}, {{plz}} {{stadt}}</p>

              <p>{{jahr}}. Klasse, {{schultyp}}<br>
              Fächer: {{faecher}}</p>

              <p>Probetermin-Vorschläge: <br>{{vorschlag_1}}<br> {{vorschlag_2}}<br> {{vorschlag_3}}</p>`,
              "type": "html",
              "data": {
                faecher: this.implode(this.subjectData.rows),
                jahr: this.subjectData.year,
                schultyp: this.subjectData.schooltype,
                strasse: this.personalData.route,
                hausnummer: this.personalData.street_number,
                plz: this.personalData.postal_code,
                stadt: this.personalData.locality,
                vorname: this.contactData.forename,
                nachname: this.contactData.lastname,
                telefon: this.contactData.phone,
                mail: this.contactData.mail,
                vorschlag_1: this.dateFormatReadable(this.dateData.dateOne),
                vorschlag_2: this.dateFormatReadable(this.dateData.dateTwo),
                vorschlag_3: this.dateFormatReadable(this.dateData.dateThree)
              }
            }, {
              headers: {
                  "Authorization" : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1Ni20",
                  "Content-Type"  : "application/json"
              }}
          )
          .then(response => (self.info = response))
          .catch(error => console.log(error))

          this.stepActive = 6;
      },

      dateFormatReadable: function (value) {
        if (!value) return ''
        var d = new Date(value)
        return ('0'+d.getDate()).slice(-2) +'.'+ ('0'+(d.getMonth()+1)).slice(-2) +'.'+ d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2);
      },

      implode: function(array) {
        var string = '';
        array.forEach(function(item) {
          string = item['subject'] + ', ' + string;
        })
        string = string.slice(0,-2);
        return string;
      },

      dateFormat: function (value) {
        if (!value) return null
        var d = new Date(value)
        return d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0'+d.getDate()).slice(-2) + ' ' + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2) + ":" + ('0' + d.getSeconds()).slice(-2);
      }
    }
  }
</script>

<style lang="less">
  @import "./assets/vendor/fontawesome/less/fontawesome";
  @import "./assets/vendor/fontawesome/less/solid";

  @import './assets/less/style.less';

  #nav {
    display: flex;
    background: #a7a7a7;
    line-height: 1rem;
    position: relative;


    div {
      width: 25%;

    }
    a {
      /*display: none;*/
      .font2;
      color: #fff;
      text-decoration: none;
      font-size: 1.5rem;
      line-height: 1.5rem;
      display: block;
      width: 100%;
      box-shadow: 0 0 3px #333;
      padding: 1.5rem;
      box-sizing: border-box;
      text-align: center;
      cursor: default;
      background: #a7a7a7;
      overflow: hidden;
      white-space: nowrap;

      &.active {
        display: inline-block;
        background-color: @primary;
        position: relative;
        z-index: 1;
        padding-top: 2rem;
        margin-top: -1rem;
        padding-bottom: 2rem;
      }
      &.done {
        background-color: #6f6f6f;
      }
    }
    i {
      margin-right: 0.5rem;
    }

    .4 {
      display: none;
    }
    .step-finish {
      display: none;
      position: absolute;
      width: 100%;
      background: #4d9aa2;
      box-sizing: border-box; 
      &.active {
        display: block;
        width: 100%;
        left: 0;
      }
    }

    @media (max-width: 850px) {
      div {
        width: 13%;
      }
      div.active {
        width: 50%;
      }  
    }
  }

  .logo {
    position: absolute;
    width: 100%;
    height: 17%;
    display: flex;
    justify-content: center;

    img {
      max-width: 270px;
      width: 100%;
      height: auto;
    }

    @media (max-width: 850px) {
      position: relative;
      top: 0;
      margin: 0;
      transform: none;
      left: 0;
    }
  }

  .tabs {
    .v-middle;
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    padding: 1rem;

    #tabs-body {
      position: relative;
      z-index: 10;
      background-color: #ffffff;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
      padding: 3rem;
      
      > div:not(.prevnext-buttons) {
        display: none;

        &.active {
          display: block;
        }
      }
    }

    @media (max-width: 850px) {
      top: 0;
      transform: none;
    }

  }

  .prevnext-buttons {
    margin-top: 5rem;

    .next-button, .submit-button {
      text-align: right;
    }
    .back-button a {
      padding: 0.7rem;
      margin-top: 1.4rem;
    }
  }

</style>